exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-45c69900]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:100;display:flex;flex-direction:column;justify-content:flex-end;transition:background-color .5s ease;background-color:transparent}.wrapper.is-active[data-v-45c69900]{background-color:#00000073}", ""]);

// exports
